<template>
  <div class="cart-products seccion-gris">
    <section>
      <CartBreadcumbs :stepActive="1" />
      <div class="container cart-container">
        <div class="row">
          <div class="col-sm-12">
            <div class="card shadow-sm carrito mb-3 card-carrito-detalle">
              <div class="card-body">
                <h4 class="h4-carrito text-primary" style="float: left;">Mi Carrito</h4>
                <router-link
                  :to="'/productos'"
                  style="float: right;color: grey;text-decoration: none;"
                  >Seguir comprando</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-sm-12">
            <CartDetails :cartProducts="cartProducts" />
          </div>
          <div class="col-lg-4 col-sm-12">
            <CartCalculator
              :totalValue="totalValue"
              :general_allowed_sale="general_allowed_sale"
              :general_allowed_tpv="general_allowed_tpv"
            />
          </div>
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import CartBreadcumbs from '@/components/products/cart/components/CartBreadcumbs.vue';
import CartCalculator from '@/components/products/cart/CartProductsStepOne/components/CartCalculator.vue';
import CartDetails from '@/components/products/cart/CartProductsStepOne/components/CartDetails.vue';
import { config_settings } from '@/config.js';
import '@/components/products/cart/CartStyles.scss';

export default {
  name: 'CartProductsStepOne',
  components: { CartCalculator, CartBreadcumbs, CartDetails, GoToTrackingModule, GuideModule },
  computed: mapState(['cartProducts']),
  data() {
    return {
      totalValue: 0.0,
      general_allowed_sale: true,
      general_allowed_tpv: true,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    analizeCart() {
      let actual_total = 0;
      this.general_allowed_sale = true;
      this.cartProducts.forEach((product, index) => {
        if (product.allowed_sale == false) {
          this.general_allowed_sale = false;
        }
        if (product.allowed_tpv == false) {
          this.general_allowed_tpv = false;
        }
        var subtotal = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
      });
      this.totalValue = Math.round(actual_total * 100) / 100;
    },
  },

  created() {
    this.scrollToTop();
  },
};
</script>
